import $ from 'jquery';
import 'slick-carousel';
import dayjs from 'dayjs';
import Util from './util';

export default class Getters {
  constructor() {
    this.utilInstance = new Util();
    this.viewProperty = {
      image: '物件画像',
      name: '物件名称',
      update: '更新日',
      landArea: '敷地面積',
      buildingArea: '建物面積',
      floorPlan: '間取り',
      detailUrl: '物件詳細URL',
    };
  }

  getPropertiesData(array, select, length) {
    const replaceMobileLink = (detailUrl) =>
      detailUrl

    const numbers = `
      <p class="property-length">
        <span>${length}件</span>
        <span>の絞り込み結果</span>
      </p>
      <p class="property-list-caution">※近場の駅が複数ある物件は1つにまとめて表示されます。</p>
    `;
    $('.js-property-list-title').html(numbers);

    const sorts = `
      <div class="property-sort">
        <p>並び順：</p>
        <select name="sort" class="js-property-sort">
          ${select
            .map(
              (s) =>
                `<option key="${s.key}" ${s.selected ? 'selected' : ''}>${
                  s.value
                }</option>`
            )
            .join('\n')}
        </select>
      </div>
    `;
    $('.js-property-select-area').html(sorts);

    const items = array.map((item) => {
      return `
        <li class="property-item">
          <div class="property-thumb">
          ${
            dayjs(item[this.viewProperty.update]).diff(dayjs(), 'week') > -2
              ? '<span class="property-tag">NEW</span>'
              : ''
          }
            <img src="${item[this.viewProperty.image]}" alt="${
              item[this.viewProperty.name]
            }">
          </div>
          <div class="property-header">
            <p class="property-intro">
              ${(() => {
                if (
                  String(item[this.utilInstance.formulaWalkingInfo(item)])
                    .length !== 0
                ) {
                  return `
                  最寄り駅 ${item[this.utilInstance.formulaProperties(item)]}駅
                    徒歩${item[this.utilInstance.formulaWalkingInfo(item)]}分
                  `;
                } else {
                  return `
                  最寄り駅 ${
                    this.utilInstance.formulaBusInfo(item).trainStation
                  }駅から
                    ${this.utilInstance.formulaBusInfo(item).busStation}まで
                    バスで${
                      this.utilInstance.formulaBusInfo(item).rideTime
                    }分<br>
                    ${
                      this.utilInstance.formulaBusInfo(item).busStation
                    }から 徒歩
                    ${this.utilInstance.formulaBusInfo(item).minuteFromBus}分
                  `;
                }
              })()}
            </p>
            <p class="property-name">${item[this.viewProperty.name]}</p>
          </div>
          <div class="property-body">
            <table>
              <tbody>
                <tr>
                  <th>販売価格</th>
                  <td>
                    <p class="property-prise">${this.utilInstance.formulaSalesPrice(
                      item
                    )}</p>
                  </td>
                </tr>
                ${(() => {
                  if (this.utilInstance.setTrafficInfo(item).length !== 0) {
                    return `
                      <tr>
                        <th>その他<br>交通</th>
                        <td>
                          ${(() => {
                            const traffics =
                              this.utilInstance.setTrafficInfo(item);
                            for (let i = 0; i < traffics.length; i++) {
                              if (traffics[i].minute !== undefined) {
                                return `<p class="property-value">${traffics[i].station} 徒歩${traffics[i].minute}分</p>`;
                              } else {
                                return `
                                  <p class="property-value">
                                    ${traffics[i].station}駅から
                                    ${traffics[i].busStation}まで
                                    バスで${traffics[i].rideTime}分<br>
                                    ${traffics[i].busStation}から 徒歩
                                    ${traffics[i].walkFromBusStop}分
                                  </p>
                                `;
                              }
                            }
                          })()}
                        </td>
                      </tr>
                    `;
                  } else {
                    return ``;
                  }
                })()}
                ${(() => {
                  if (item[this.viewProperty.landArea].length !== 0) {
                    return `
                      <tr>
                        <th>土地面積</th>
                        <td>
                          <p class="property-value">${
                            item[this.viewProperty.landArea]
                          }</p>
                        </td>
                      </tr>
                    `;
                  } else {
                    return ``;
                  }
                })()}
                ${(() => {
                  if (item[this.viewProperty.buildingArea].length !== 0) {
                    return `
                      <tr>
                        <th>建売面積</th>
                        <td>
                          <p class="property-value">${
                            item[this.viewProperty.buildingArea]
                          }</p>
                        </td>
                      </tr>
                    `;
                  } else {
                    return ``;
                  }
                })()}
                ${(() => {
                  if (item[this.viewProperty.floorPlan].length !== 0) {
                    return `
                      <tr>
                        <th>間取り</th>
                        <td>
                          <p class="property-value">${
                            item[this.viewProperty.floorPlan]
                          }</p>
                        </td>
                      </tr>
                    `;
                  } else {
                    return ``;
                  }
                })()}
              </tbody>
            </table>
            <a href="${
              item[this.viewProperty.detailUrl]
            }" target="_blank" class="is-pc">
              <span>物件詳細を見る</span>
              <span>
                <img src="../images/icons/chevron-right.png" alt="">
              </span>
            </a>
            <a href="${replaceMobileLink(
              item[this.viewProperty.detailUrl]
            )}" target="_blank" class="is-sp">
              <span>物件詳細を見る</span>
              <span>
                <img src="../images/icons/chevron-right.png" alt="">
              </span>
            </a>
          </div>
        </li>
      `;
    });

    $('.js-property-list').html(items);
  }

  getStationList(stationList, selectList) {
    const breakpoint = (width) => window.matchMedia(`(max-width: ${width}px)`);
    let splitNum = 0;
    let columnWidth = 0;
    let marginRight = 0;
    let overMargin = 0;

    if (breakpoint(357).matches) {
      splitNum = 4;
      columnWidth = 62;
      marginRight = 8;
      overMargin = 13;
    } else if (breakpoint(373).matches) {
      splitNum = 4;
      columnWidth = 68;
      marginRight = 12;
      overMargin = 13;
    } else if (breakpoint(768).matches) {
      splitNum = 4;
      columnWidth = 72;
      marginRight = 12;
      overMargin = 13;
    } else {
      if (breakpoint(773).matches) {
        splitNum = 2;
      } else if (breakpoint(893).matches) {
        splitNum = 3;
      } else if (breakpoint(1013).matches) {
        splitNum = 4;
      } else if (breakpoint(1133).matches) {
        splitNum = 5;
      } else if (breakpoint(1253).matches) {
        splitNum = 6;
      } else if (breakpoint(1373).matches) {
        splitNum = 7;
      } else {
        splitNum = 8;
      }
      columnWidth = 100;
      marginRight = 20;
      overMargin = 24;
    }

    const arrayChunk = ([...array], size = 1) => {
      return array.reduce(
        (acc, value, index) =>
          index % size ? acc : [...acc, array.slice(index, index + size)],
        []
      );
    };

    let registerArr = [];
    let allSelect = false;
    stationList.map((r) => {
      if (r.stations.length === 1) {
        r.stations[0].map((s) => {
          if (s.count !== 0) {
            registerArr.push(s.name);
          }
        });
      } else {
        const stations = r.stations;
        for (let i = 0; i < stations.length; i++) {
          stations[i].map((s) => {
            if (s.count !== 0) {
              registerArr.push(s.name);
            }
          });
        }
      }
    });

    if (
      selectList.filter((i) => registerArr.indexOf(i.name) == -1).length ===
      registerArr.length
    ) {
      allSelect = true;
    } else {
      allSelect = false;
    }

    const checkbox = `
      <ul class="station-check-list">
        <li class="station-check-item">
          <input type="radio" class="js-check-station-clear" name="stations" ${
            !selectList.length ? 'checked' : ''
          } />
          <span></span>
          <span class="station-radio-text">選択を解除</span>
        </li>
        <li class="station-check-item">
          <input type="radio" class="js-check-station-all" name="stations" ${
            allSelect ? 'checked' : ''
          } />
          <span></span>
          <span class="station-radio-text">全ての駅を選択</span>
        </li>
      </ul>
    `;
    $('.js-station-checkbox').html(checkbox);

    const stations = stationList.map((r, rid) => {
      r.stations.map((s) => {
        let lastIndex = s.indexOf(s.slice(-1)[0]);
        if (s.length >= 3) {
          for (let i = 0; i < s.length; i++) {
            if (
              i !== 0 &&
              i !== lastIndex &&
              i !== lastIndex + 1 &&
              s[i - 1].count &&
              !s[i].count &&
              !s[i + 1].count
            ) {
              s[i + 1].disabled = true;
            } else if (
              i !== lastIndex &&
              i !== lastIndex + 1 &&
              i !== 0 &&
              !s[i].count &&
              !s[i + 1].count
            ) {
              s[i].disabled = true;
            } else if (i === lastIndex) {
              s[i].disabled = false;
            } else {
              s[i].disabled = false;
            }
          }
        }
      });
      return `
        <div class="station-list">
          <p class="station-railway-name">${r.viewName}</p>
          ${
            r.stations.length === 1
              ? `
              <div class="station-list-box">
                ${r.stations
                  .map((s) =>
                    s
                      .map(
                        (t) =>
                          `
                        <div class="station-item ${
                          t.select ? 'is-select' : 'is-not-select'
                        } ${t.disabled ? 'is-disabled' : 'is-not-disabled'}">
                          <button type="button" class="js-station-item" ${
                            t.count === 0 ? 'disabled' : ''
                          } data-value="${t.name}" data-rid="${rid}" title="${
                            t.name
                          }">
                            <div class="station-head">
                              <span class="station-check"></span>
                              <p class="station-property-length">${t.count}</p>
                            </div>
                            <div class="station-body">
                              <p class="station-name">${t.name}</p>
                            </div>
                          </button>
                        </div>
                       `
                      )
                      .join('\n')
                  )
                  .join('\n')}
                ${
                  r.stations[0].filter((s) => !s.disabled).length > splitNum
                    ? arrayChunk(
                        r.stations[0].filter((s) => !s.disabled),
                        splitNum
                      )
                        .map(
                          (c) =>
                            `<span class="station-line is-multiple" style="width: ${
                              c.length * columnWidth +
                              (c.length - 1) * marginRight +
                              overMargin
                            }px"></span>`
                        )
                        .join('\n')
                    : `<span class="station-line" style="width: ${
                        r.stations[0].filter((s) => !s.disabled).length *
                          columnWidth +
                        (r.stations[0].filter((s) => !s.disabled).length - 1) *
                          marginRight
                      }px"></span>`
                }
              </div>
            `
              : r.stations
                  .map(
                    (a) =>
                      `
                <p class="branch-name">${a[0].branch}</p>
                <div class="station-branch-box">
                  ${a
                    .map(
                      (s) =>
                        `
                        <div class="station-item ${
                          s.select ? 'is-select' : 'is-not-select'
                        } ${s.disabled ? 'is-disabled' : 'is-not-disabled'}">
                          <button type="button" class="js-station-item" ${
                            s.count === 0 ? 'disabled' : ''
                          } data-value="${s.name}" data-rid="${rid}" title="${
                          s.name
                        }" >
                            <div class="station-head">
                            <span class="station-check"></span>
                              <p class="station-property-length">${s.count}</p>
                            </div>
                            <div class="station-body">
                              <p class="station-name">${s.name}</p>
                            </div>
                          </button>
                        </div>
                      `
                    )
                    .join('\n')}
                  ${
                    a.filter((s) => !s.disabled).length > splitNum
                      ? arrayChunk(
                          a.filter((s) => !s.disabled),
                          splitNum
                        )
                          .map(
                            (c) =>
                              `<span class="station-line is-multiple" style="width: ${
                                c.length * columnWidth +
                                (c.length - 1) * marginRight +
                                overMargin
                              }px"></span>`
                          )
                          .join('\n')
                      : `<span class="station-line" style="width: ${
                          a.filter((s) => !s.disabled).length * columnWidth +
                          (a.filter((s) => !s.disabled).length - 1) *
                            marginRight
                        }px"></span>`
                  }
                </div>
              `
                  )
                  .join('\n')
          }
        </div>
      `;
    });

    $('.js-station-inner').html(stations);
  }

  getPaginationData(obj) {
    if (obj.viewData.length !== 0 && obj.totalPage > 1) {
      let pages = `
      <li>
        ${(() => {
          if (obj.page === 1) {
            return `
              <button class="js-prev-button" type="button" disabled>
                <img src="../images/icons/chevron-right__blue.png" alt="">
                <span>前へ</span>
              </button>
            `;
          } else {
            return `
              <button class="js-prev-button" type="button">
                <img src="../images/icons/chevron-right__blue.png" alt="">
                <span>前へ</span>
              </button>
            `;
          }
        })()}
      </li>
      `;
      for (let i = 0; i < obj.totalPage; i++) {
        pages += `
          ${(() => {
            if (obj.page === i + 1) {
              return `<li><button class="js-pagination-button is-current" type="button" disabled>${
                i + 1
              }</button></li>`;
            } else {
              return `<li><button class="js-pagination-button" type="button">${
                i + 1
              }</button></li>`;
            }
          })()}
        `;
      }
      pages += `
        <li>
          ${(() => {
            if (obj.totalPage === obj.page) {
              return `
                <button class="js-next-button" type="button" disabled>
                  <span>次へ</span>
                  <img src="../images/icons/chevron-left__blue.png" alt="">
                </button>
              `;
            } else {
              return `
                <button class="js-next-button" type="button">
                  <span>次へ</span>
                  <img src="../images/icons/chevron-left__blue.png" alt="">
                </button>
              `;
            }
          })()}
        </li>
      `;

      $('.js-pagination').html(pages);
    } else {
      $('.js-pagination').children().remove();
    }
  }

  setSlickCarousel() {
    const slider = $('.js-thumbnail-slider').slick({
      dots: false,
      infinite: true,
      centerMode: true,
      centerPadding: '231px',
      autoplay: true,
      autoplaySpeed: 2500,
      speed: 1500,
      fade: false,
      initialSlide: 0,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerPadding: '50px',
            slidesToShow: 1,
          },
        },
      ],
    });

    $('#js-slick-prev').on('click', () => {
      slider.slick('slickPrev');
    });
    $('#js-slick-next').on('click', () => {
      slider.slick('slickNext');
    });
  }
}
